import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['editContainer', 'readonlyContainer', 'cancelButton']

  readonly() {
    this.toggleForm(false)
  }

  edit() {
    this.toggleForm(true);
  }

  toggleForm(toggled) {
    this.readonlyContainerTarget.classList.toggle('d-none', toggled);
    this.editContainerTarget.classList.toggle('d-none', !toggled);
    this.cancelButtonTarget.classList.toggle('d-none', !toggled);
  }
}
